import { render } from "./TarikIbayaq.vue?vue&type=template&id=37dac6f9"
import script from "./TarikIbayaq.vue?vue&type=script&lang=js"
export * from "./TarikIbayaq.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__